import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

const useCommonProductColumnDefs = ({
  productList,
  gridData,
  hasUpdateLeadPermission,
  handleClickEdit,
  openDeletePopup,
}) => {
  let hasInfoLeadPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.leadmenu;

  if (userUIControlPermission) {
    hasInfoLeadPermission = userUIControlPermission?.leadinfoscreen
      ? userUIControlPermission.leadinfoscreen.canView
      : true;
  }
  const [showPopup2, setShowPopup2] = useState(false);
  const [editData, setEditData] = useState([]);
  const [showPopup3, setShowPopup3] = useState(false);
  const [deleteData, setDeleteData] = useState([]);

  // const handleClickEdit = (data) => {
  //   setShowPopup2(true);
  //   setEditData({
  //     ...data,
  //     type: "edit",
  //   });
  // };

  // Function to open the third popup
  // const openPopup3 = (data) => {
  //   setShowPopup3(true);
  //   setDeleteData(data);
  // };

  const columnDefs = useMemo(() => {
    return [
      {
        headerName: 'Actions',
        // headerCheckboxSelection: true,
        // checkboxSelection: true,
        cellRenderer: (params) => {
          const paramsValue = { ...params.data };
          return (
            <div className="action-menu">
              {/* {hasUpdateLeadPermission && ( */}
              <>
                <img
                  src="/assets/images/edit.png"
                  className="action-img1"
                  onClick={() => handleClickEdit(paramsValue)}
                  alt="Edit Lead"
                  title="Edit Lead"
                ></img>
                <img
                  src="/assets/images/trash.png"
                  className="action-img2"
                  onClick={() => openDeletePopup(paramsValue)}
                  alt="UnAssign Lead"
                  title="UnAssign Lead"
                ></img>
              </>
              {/* )} */}
            </div>
          );
        },
        maxWidth: 120,
        sortable: false,
        filter: false,
        pinned: 'left',
      },
      {
        headerName: 'Product Name',
        field: 'productName',
        width: 150,
        filter: 'agSetColumnFilter',
        cellRenderer: (params) => {
          if (!params.value || params.node.group) return params.value;

          // Conditionally make the name clickable if permission exists
          return hasInfoLeadPermission ? (
            <Link
              to={`/products/productList/viewProduct?id=${params.data.id}&pageNo=${gridData?.inputPayload?.pageNumber}`}
              state={params.data}
              style={{ fontWeight: '600' }}
            >
              {params.value}
            </Link>
          ) : (
            <span style={{ fontWeight: '600' }}>{params.value}</span>
          );
        },
      },
      {
        headerName: 'Product Code',
        field: 'productCode',
        width: 150,
        filter: 'agSetColumnFilter',
      },
      {
        headerName: 'Product Active',
        field: 'email',
        width: 150,
        filter: 'agSetColumnFilter',
      },
      {
        headerName: 'Manufacturer',
        field: 'manufacturer',
        width: 150,
        filter: 'agSetColumnFilter',
      },
      {
        headerName: 'List Price',
        field: 'listPrice',
        width: 150,
        filter: 'agSetColumnFilter',
      },
      {
        headerName: 'Support Start Date',
        field: 'supportStartDate',
        width: 150,
        filter: 'agSetColumnFilter',
      },
      {
        headerName: 'Support End Date',
        field: 'supportEndDate',
        width: 150,
        filter: 'agSetColumnFilter',
      },
    ];
  }, [productList, gridData]);

  return columnDefs;
};

export default useCommonProductColumnDefs;
